(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["saltwater-club-preview"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.swReady) return;
    root.dataset.swReady = 'true';
    const memberLink = root.querySelector('[data-sw-member]');
    if (memberLink) {
      const memberUrl = new URL(window.location.href);
      memberUrl.searchParams.set('open_joy', 'joy-open');
      memberUrl.hash = '';
      memberLink.href = memberUrl.toString();
    }
    const dialog = root.querySelector('dialog');
    const opener = root.querySelector('[data-sw-open]');
    if (!dialog || !opener || typeof dialog.showModal !== 'function') return;
    let previousOverflow = '';
    opener.addEventListener('click', () => {
      if (dialog.open) return;
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      dialog.querySelector('[data-sw-close]').focus();
    });
    root.querySelectorAll('[data-sw-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if(event.key !== 'Tab') return;
      const items = Array.from(dialog.querySelectorAll('a[href], button:not([disabled])'));
      const first = items[0], last = items[items.length - 1];
      if(event.shiftKey && document.activeElement === first){ event.preventDefault(); last.focus(); }
      else if(!event.shiftKey && document.activeElement === last){ event.preventDefault(); first.focus(); }
    });
    dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; opener.focus(); });
    (root.closest('.shopify-section') || root).addEventListener('shopify:section:unload', () => { if(dialog.open){ dialog.close(); document.body.style.overflow = previousOverflow; } });
  };
  const initializeAll = () => document.querySelectorAll('[data-sw-club]').forEach(initialize);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true}); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();

  } catch(e) { console.error(e); }
})();
})();
